import Button, { ButtonVariant } from '@ben/orion/deprecated-button';
import Typography, { TypographyVariant } from '@ben/orion/typography';
import { useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import styled, { css } from 'styled-components';
import ModularDropdownInputOption from './modular-dropdown-input-option';

export interface ModularDropdownInputOptionsProps {
  componentControllerName: string;
  subTitleText: string;
  isMultiSelectInput?: boolean;
  hasSubform?: boolean;
}

const ModularDropdownInputOptions = ({
  componentControllerName,
  subTitleText,
  isMultiSelectInput = false,
  hasSubform = false,
}: ModularDropdownInputOptionsProps) => {
  const { control, getFieldState } = useFormContext();
  const {
    fields: optionsFields,
    append: appendOption,
    remove: removeOption,
  } = useFieldArray({
    control,
    name: `${componentControllerName}.options`,
  });

  useEffect(() => {
    if (optionsFields.length === 0) {
      appendOption({ label: '', key: '', rank: 1 });
    }
  }, [appendOption, optionsFields.length]);

  return (
    <>
      <TitleWrapper>
        <Typography variant={TypographyVariant.bodyMd2}>Options</Typography>
        <Typography variant={TypographyVariant.bodyMd1}>
          {subTitleText}
        </Typography>
      </TitleWrapper>
      {optionsFields.map((option, index) => {
        const optionFieldState = getFieldState(
          `${componentControllerName}.options.${index}`
        );
        return (
          <ModularDropdownInputOption
            componentControllerName={`${componentControllerName}.options[${index}]`}
            error={optionFieldState.error}
            onRemove={() => removeOption(index)}
            hasSubform={hasSubform}
            isMultiSelectInput={isMultiSelectInput}
            key={option.id}
          />
        );
      })}

      <Button
        label="Add option"
        variant={ButtonVariant.secondary}
        onClick={() =>
          appendOption({ label: '', key: '', rank: optionsFields.length + 1 })
        }
      />
    </>
  );
};

export default ModularDropdownInputOptions;

const TitleWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
  `}
`;
